import * as dayjs from "dayjs";
import Actions from "./actions";

const appReducer = (state, action) => {
	switch (action.type) {
		case Actions.SET_LOADING: {
			return { ...state, isLoading: action.payload };
		}
		case Actions.SET_SOV_MOBILE_VIEW: {
			return { ...state, sovSimplifiedSearchBar: action.payload };
		}
		case Actions.SET_SOV_TABLET_VIEW: {
			return { ...state, sovTablet: action.payload };
		}
		case Actions.SET_SOV_DESKTOP_VIEW: {
			return { ...state, sovDesktop: action.payload };
		}
		case Actions.UPDATE_LANGUAGE: {
			dayjs.locale(action.payload === "fr" ? "fr-ca" : "en-ca");
			return { ...state, lang: action.payload };
		}
		case Actions.SET_DICTIONARY: {
			const { RCLServiceFetch, lang } = action.payload;
			return {
				...state,
				getDictionary: key => RCLServiceFetch.value(lang, key),
			};
		}
		case Actions.SET_SESSION_MANAGER: {
			return {
				...state,
				SessionManager: action.payload,
			};
		}
		default: {
			throw new Error(`Unhandled action type: ${action.type}`);
		}
	}
};

export default appReducer;
